import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { TripsPage } from "@/features/trips/pages/trips-page/trips-page";
import { tripsFiltersSchema } from "@/features/trips/schemas/trips-filters.schema";
import { prefetchMyVehicles } from "@/features/vehicles/api/get-my-vehicles/prefetch-my-vehicles";
import { prefetchVehicleClientPreferences } from "@/features/vehicles/api/get-vehicle-client-preferences/prefetch-vehicle-client-preferences";

export const Route = createFileRoute("/_authenticated/driver/my-trips")({
	head: () => pageTitle("My trips"),
	component: TripsPage,
	validateSearch: zodValidator(tripsFiltersSchema),
	async loader({ context }) {
		const { queryClient } = context;

		const vehicles = await prefetchMyVehicles({
			queryClient,
			platform: "driver",
		});

		await Promise.all(
			vehicles.map((vehicle) =>
				prefetchVehicleClientPreferences({
					queryClient,
					platform: "driver",
					vehicleId: vehicle.id!,
				})
			)
		);
	},
});
